import { DataService } from '../../shared/services/data.service';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { isPlatformServer } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { LoaderService } from './services/loader.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { TransferState, makeStateKey } from '@angular/core';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { map } from 'rxjs/operators';
const ACTIVE_PRODUCTS_KEY = makeStateKey<any>('activeProductsCache');
@Injectable({
  providedIn: 'root'
})
export class CatalogService {
  private forfaitsData: Record<string, Product[]> = {};
  forfaits: Record<string, Product[]> = {};
    momentForfaits: Record<string, Product[]> = {};
    allProducts: Product[] = [];
    private activeProductsCache$: Observable<any> | null = null;
 constructor(@Inject(PLATFORM_ID) private platformId: Object,private httpClient: HttpClient,private loaderService: LoaderService,
  private transferState: TransferState) { }
 getActiveProductByUrl(urlName:any){

 const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url=`${apiUrl}/Product/GetDetailByUrlWithMeta?urlName=`+urlName;
     var result = this.httpClient.get(url);
    return result;
  }
  getActiveProduct(op:string){
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url= `${apiUrl}/Product/GetActivatedProducts?operateur=`+op;
     return  this.httpClient.get(url);
  }
  getProductBy(operateur:any,price:any,volume:any,option:any, maxPrice:any){
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url= `${apiUrl}/Product/GetProductForV2?operateur=`+ operateur+"&price="+price+"&volume="+volume+"&option="+option+"&maxPrice="+ maxPrice;
     return  this.httpClient.get(url);
  }
  GetProductForV2ByUrlFilter(url:any){
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;

    let urlName= `${apiUrl}/Product/GetProductForV2ByUrlFilter?url=`+ url;
    //  return  this.httpClient.get(urlName);
     return this.httpClient.get<ProductResponse>(urlName);
  }
  GetProductFooterForV2ByUrlFilter(url:any){
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let urlName= `${apiUrl}/Product/GetProductFooterForV2ByUrlFilter?url=`+ url;
     return  this.httpClient.get(urlName);
  }
  // GetActiveProductForV2()  {
  //   const isSSR = isPlatformServer(this.platformId);
  //   const apiUrl = isSSR
  //   ? `${environment.apiUrlLocal}`
  //   : `${environment.apiUrl}`;
  //   let url= `${apiUrl}/Product/GetAvtiveProductForV2`;
  //   return this.httpClient.get(url);
  // }
  // GetActiveProductForV2(): Observable<any> {
  //   if (!this.activeProductsCache$) {
  //     const isSSR = isPlatformServer(this.platformId);
  //     const apiUrl = isSSR
  //     ? `${environment.apiUrlLocal}`
  //     : `${environment.apiUrl}`;
  //     let url= `${apiUrl}/Product/GetAvtiveProductForV2`;
  //     this.activeProductsCache$ = this.httpClient.get(url).pipe(
  //       shareReplay(1)
  //     );
  //   }
  //   return this.activeProductsCache$;
  // }
  GetActiveProductForV2(): Observable<any> {
    // 1. Si on a le cache du serveur (Browser), on l'utilise (il sera DÉJÀ nettoyé !)
    if (this.transferState.hasKey(ACTIVE_PRODUCTS_KEY)) {
      const cachedData = this.transferState.get(ACTIVE_PRODUCTS_KEY, null);
      this.activeProductsCache$ = of(cachedData).pipe(shareReplay(1));
      return this.activeProductsCache$;
    }

    // 2. Sinon, on fait l'appel API (Serveur)
    if (!this.activeProductsCache$) {
      const isSSR = isPlatformServer(this.platformId);
      const apiUrl = isSSR
        ? `${environment.apiUrlLocal}`
        : `${environment.apiUrl}`;
      let url = `${apiUrl}/Product/GetAvtiveProductForV2`;
      
      this.activeProductsCache$ = this.httpClient.get(url).pipe(
        // ÉTAPE CRUCIALE : On nettoie TOUTES les URLs globalement ici
        map(data => {
          const cleanData = JSON.parse(JSON.stringify(data)); // Clone profond de sécurité
          
          // Object.values(cleanData).flat().forEach((product: any) => {
          //   if (product && product.urlName) {
          //     const parts = product.urlName.split('-');
          //     const lastPart = parts[parts.length - 1].toLowerCase();
              
          //     // On coupe si ça se termine par un opérateur
          //     if (['orange', 'sfr', 'bouygues'].includes(lastPart)) {
          //       product.urlName = parts.slice(0, -1).join('-');
          //     }
          //   }
          // });
          Object.values(cleanData).flat().forEach((product: any) => {
  if (product && typeof product.urlName === 'string') {
    // La regex cherche "-orange", "-sfr" ou "-bouygues" à la toute fin ($) de la chaîne, 
    // en ignorant la casse (i) et le remplace par du vide ''.
    product.urlName = product.urlName.replace(/-(orange|sfr|bouygues)$/i, '');
  }
});
          
          return cleanData; // On retourne les données propres
        }),
        tap(cleanData => {
          // 3. On sauvegarde les données PROPRES dans le HTML pour le navigateur
          if (isSSR) {
            this.transferState.set(ACTIVE_PRODUCTS_KEY, cleanData);
          }
        }),
        shareReplay(1)
      );
    }
    
    return this.activeProductsCache$;
  }
  filterForfaits(): void {
    if (!Array.isArray(this.allProducts) || this.allProducts.length === 0) {
      console.warn('No products to filter');
      return;
    }
    const filtered = this.allProducts.filter((product: Product) => product.isMomenProduct === false);
    this.forfaits = filtered.reduce((acc: Record<string, Product[]>, product: Product) => {
      if (!acc[product.operators]) {
        acc[product.operators] = [];
      }
      acc[product.operators].push(product);
      return acc;
    }, {});
    const filtered2 = this.allProducts.filter((product: Product) => product.isMomenProduct === true);
    this.momentForfaits = filtered2.reduce((acc: Record<string, Product[]>, product: Product) => {
      if (!acc[product.operators]) {
        acc[product.operators] = [];
      }
      acc[product.operators].push(product);
      return acc;
    }, {});
  }
  setForfaits(forfaits: Record<string, Product[]>): void {
    this.momentForfaits =forfaits;
  }
}
export interface Product {
  operators: string;
  operateur: string;
  isMomenProduct: boolean;
  inclus5G: boolean;
  prix?: string;
  gigas?: string;
  reseau?: string;
  urlName: string;
  id?: string;
  classification?: string;
  promo?: boolean;
  simPrice?: number;
  maxVolume: number;
  maxTarif: number;
  fonctionalites?: string;
  fonctionalitesList?: any;
  forfaitRoamingEuropVolume: number;
  dateEndValidation?: Date;
}
export interface ProductResponse {
  products: Product[];
  metaTitle: string;
}